import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { THRESHOLDS } from '../action';

const ProximityBar = ({ t, summary }) => {
  const totalDebits = summary?.total_debits ?? 0;
  const lastContributionAmount = summary?.last_contribution?.amount ?? 0;

  const consumedRatio =
    lastContributionAmount > 0 ? totalDebits / lastContributionAmount : 0;
  const availablePercentage = Math.max(100 - consumedRatio * 100, 0);

  const suspendMarker = THRESHOLDS.suspend * 100;
  const warningMarker = THRESHOLDS.warning * 100;

  let barColor = 'bg-success';
  if (availablePercentage <= THRESHOLDS.suspend) {
    barColor = 'bg-danger';
  } else if (availablePercentage <= THRESHOLDS.warning) {
    barColor = 'bg-warning';
  }

  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h6 className="m-0 text-uppercase" style={{ fontSize: '0.75rem' }}>
            {t('wallet-overview.proximity-bar.title')}
          </h6>
          <span className="text-muted" style={{ fontSize: '0.75rem' }}>
            {t('wallet-overview.proximity-bar.balance-ratio', {
              percentage: 100.0,
            })}
          </span>
        </div>

        <div
          style={{ position: 'relative', height: '24px', marginBottom: '8px' }}
        >
          {/* Background track */}
          <div
            className="bg-light rounded"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />

          {/* Fill bar */}
          <div
            className={barColor}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: `${availablePercentage}%`,
              height: '100%',
              borderRadius: '4px',
              transition: 'width 0.5s ease',
            }}
          />

          {/* Suspend marker at 15% */}
          <div
            style={{
              position: 'absolute',
              top: '-4px',
              left: `${suspendMarker}%`,
              transform: 'translateX(-50%)',
              width: '2px',
              height: '32px',
              backgroundColor: 'var(--bs-danger)',
              zIndex: 2,
            }}
          />
          <span
            className="text-danger"
            style={{
              position: 'absolute',
              top: '26px',
              left: `${suspendMarker}%`,
              transform: 'translateX(-50%)',
              fontSize: '0.65rem',
              whiteSpace: 'nowrap',
              zIndex: 2,
            }}
          >
            {suspendMarker}%
          </span>

          {/* Warning marker at 30% */}
          <div
            style={{
              position: 'absolute',
              top: '-4px',
              left: `${warningMarker}%`,
              transform: 'translateX(-50%)',
              width: '2px',
              height: '32px',
              backgroundColor: 'var(--bs-warning)',
              zIndex: 2,
            }}
          />
          <span
            style={{
              position: 'absolute',
              top: '26px',
              left: `${warningMarker}%`,
              transform: 'translateX(-50%)',
              fontSize: '0.65rem',
              color: 'var(--bs-warning)',
              whiteSpace: 'nowrap',
              zIndex: 2,
            }}
          >
            {warningMarker}%
          </span>
        </div>

        {/* Legend */}
        <div
          className="d-flex flex-wrap gap-3 mt-3 pt-2"
          style={{ fontSize: '0.7rem' }}
        >
          <div className="d-flex align-items-center gap-1">
            <div
              className="bg-danger rounded"
              style={{ width: '10px', height: '10px' }}
            />
            <span>{t('wallet-overview.proximity-bar.suspend-label')}</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <div
              className="bg-warning rounded"
              style={{ width: '10px', height: '10px' }}
            />
            <span>{t('wallet-overview.proximity-bar.warning-label')}</span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default withTranslation()(ProximityBar);
